function infiniteScroll() {
  const mainGrid = document.querySelector('#product-grid');
  const infiniteScrollElement = document.querySelector('.infinite__scroll--button-wrap');
  const lastClickedPageURL = localStorage.getItem('lastClickedPageNumber');
  const lastClickedProductID = localStorage.getItem('lastClickedProductId');
  let currentPageNumber = 1;
  localStorage.removeItem('lastClickedPageNumber');
  localStorage.removeItem('lastClickedProductId');

  function getPageNumberFromURL(url) {
    const match = url.match(/page=(\d+)/);
    return match ? parseInt(match[1]) : 1;
  }

  const lastClickedPageNumber = lastClickedPageURL ? getPageNumberFromURL(lastClickedPageURL) : 1;

  function scrollToProduct(productId) {
    const productElement = document.querySelector(`[data-product-id="${productId}"]`);
    console.log(productElement)
    if (productElement) {
      productElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  if (infiniteScrollElement) {
    const Ajaxbutton = infiniteScrollElement.querySelector("#ajaxcall");
    let isLoading = false;

    if (Ajaxbutton && mainGrid) {
      let nextPageURL = Ajaxbutton.getAttribute('href');
      let Loading_More = infiniteScrollElement.querySelector('#loadmore');

      const loadMoreContent = () => {
        if (isLoading || !nextPageURL) return;
        isLoading = true;

        fetch(nextPageURL)
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              this.close();
              throw error;
            }
            return response.text();
          })
          .then((text) => {
            let parsedHTML = new DOMParser().parseFromString(text, 'text/html');
            let productGrid = parsedHTML.querySelector('#product-grid');
            let nextUrl = parsedHTML.querySelector('#ajaxcall');

            if (!nextUrl) {
              Loading_More.innerText = "No More Products";
              nextPageURL = null;
            } else {
              nextPageURL = nextUrl.href;
            }

            if (productGrid) {
              let newContentHTML = productGrid.innerHTML
                .replace(/class="([^"]*\bmain-collection-images-wrap\b[^"]*)"/g, 'class="$1 newly-added"')
                .replace(/class="([^"]*\bcolor-swatch\b[^"]*)"/g, 'class="$1 newly-added-swatch"')
                .replace(/class="([^"]*\bproduct-sizes\b[^"]*)"/g, 'class="$1 newly-added-size"');

              mainGrid.insertAdjacentHTML('beforeend', newContentHTML);
              setupProductClickListener();

              const newlyAddedProductCards = mainGrid.querySelectorAll('.main-collection-images-wrap.newly-added');
              // newlyAddedProductCards.forEach((container) => {
              //   if (!container.swiper) {
              //     initializeSwiperForContainer(container);
              //     container.classList.remove('newly-added');
              //   }
              // });

              const newlyAddedColorSwatches = mainGrid.querySelectorAll('.color-swatch.newly-added-swatch');
              if (newlyAddedColorSwatches.length > 0) {
                setupColorSwatchEvents(newlyAddedColorSwatches);
                newlyAddedColorSwatches.forEach((swatch) => swatch.classList.remove('newly-added-swatch'));
              }

              const newlyAddedSizeOptions = mainGrid.querySelectorAll('.product-sizes.newly-added-size');
              if (newlyAddedSizeOptions.length > 0) {
                setupSizeOptionEvents(newlyAddedSizeOptions);
                newlyAddedSizeOptions.forEach((sizeOption) => sizeOption.classList.remove('newly-added-size'));
              }
              if (currentPageNumber === lastClickedPageNumber && lastClickedProductID) {
                scrollToProduct(lastClickedProductID);
              }
            }

            isLoading = false;
            currentPageNumber++;

            if (lastClickedPageNumber && currentPageNumber < lastClickedPageNumber) {
              loadMoreContent();
            }
                        
          })
          .catch(error => {
            console.error("Error fetching data:", error);
            isLoading = false;
          });
      };

      if (lastClickedPageNumber && lastClickedPageNumber > currentPageNumber) {
        loadMoreContent();
      }

      window.addEventListener('scroll', function () {
        const mainGridRect = mainGrid.getBoundingClientRect();
        const mainGridBottom = mainGridRect.bottom + window.pageYOffset;
        const scrollPosition = window.pageYOffset + window.innerHeight;

        if (scrollPosition >= mainGridBottom) {
          loadMoreContent();
        }
      });
    }
  }
}

infiniteScroll();

function setupProductClickListener() {
  const productGrid = document.getElementById('product-grid');
  
  if (!productGrid) {
    console.error('Product grid not found');
    return;
  }

  productGrid.addEventListener('click', (event) => {
    const productLink = event.target.closest('.product-link');    
    if (productLink) {
      const productId = productLink.getAttribute('data-product-id');
      const pageNumber = productLink.getAttribute('data-current-page-number');
      
      if (productId && pageNumber) {
        localStorage.setItem('lastClickedProductId', productId);
        localStorage.setItem('lastClickedPageNumber', pageNumber);
        console.log(`Saved product ID: ${productId}, Page Number: ${pageNumber} to local storage`);
      } else {
        console.error('Product ID or Page Number not found');
      }
    }
  });
}
document.addEventListener('DOMContentLoaded', () => {
  setupProductClickListener();
});